import { PbxHttpClient } from "@/services/httpclient";

const state = {
  newMessage: null,
};

const getters = {
  GET_NEW_MESSAGE(state) {
    return state.newMessage;
  },
};

const mutations = {
  SET_NEW_MESSAGE: (state, payload) => (state.newMessage = payload),
  RESET_NEW_MESSAGE: (state) => (state.newMessage = null),
};

const actions = {
  async SET_NEW_MESSAGE({ commit }, newMessage) {
    commit("SET_NEW_MESSAGE", newMessage);
  },
  async RESET_NEW_MESSAGE({ commit }) {
    commit("RESET_NEW_MESSAGE");
  },
};

// Exportar Clientes
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
